import { createContext, useContext } from 'react';

export interface AssistantPanelState {
    /** Shown on the header toggle. */
    label: string;
    open: boolean;
    toggle: () => void;
}

/**
 * Lets a layout route that docks an assistant beside its pages put the toggle in
 * AppHeader, which each page renders itself. Null everywhere no such layout is mounted,
 * and AppHeader then draws no toggle.
 */
export const AssistantPanelContext = createContext<AssistantPanelState | null>(null);

export const useAssistantPanel = () => useContext(AssistantPanelContext);
